export default __webpack_public_path__ + "static/media/home-yoga-meditation-popular-classes-img02.f478b949.jpg";